import React from 'react'
import CompulsoryImg from '../../Images/SavingImg/CompulsorySaving.jpg'
import OptionalImg from '../../Images/SavingImg/OptionalSaving.jpg'
import DailyImg from '../../Images/SavingImg/DailySaving.jpg'
import ChildImg from '../../Images/SavingImg/ChildSaving.jpg'
import NaariImg from '../../Images/SavingImg/NaariSaving.jpg'
import JesthaNagarikImg from '../../Images/SavingImg/JesthaNagarikSaving.jpg'
import HealthImg from '../../Images/SavingImg/HealthSaving.jpg'
import AbadhikImg from '../../Images/SavingImg/AbadhikSaving.jpg'
import AkshayakoshImg from '../../Images/SavingImg/AkshayakoshSaving.jpg'
import FutureImg from '../../Images/SavingImg/FutureSaving.jpg'
import FestivalImg from '../../Images/SavingImg/FestivalSaving.jpg'
import KramikImg from '../../Images/SavingImg/KramikSaving.jpg'
import LOanPaymentImg from '../../Images/SavingImg/LoanpaymentSaving.jpg'
import PratifalImg from '../../Images/SavingImg/PratifalSaving.jpg'
import Logo from '../../Images/TopbarImg/Logo.png'
import Aos from 'aos'

const SavingAll = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    const savingList = [
        {
            id: '1',
            savingName: 'अनिवार्य बचत',
            savingImg: CompulsoryImg,
            path: '/service/saving-service/compulsory-saving'
        },
        {
            id: '2',
            savingName: 'ऐच्छिक बचत',
            savingImg: OptionalImg,
            path: '/service/saving-service/aichik-saving'
        },
        {
            id: '3',
            savingName: 'दैनिक बचत',
            savingImg: DailyImg,
            path: '/service/saving-service/daily-saving'
        },
        {
            id: '4',
            savingName: 'बाल बचत',
            savingImg: ChildImg,
            path: '/service/saving-service/child-saving'
        },
        {
            id: '5',
            savingName: 'पेवा (नारी) बचत',
            savingImg: NaariImg,
            path: '/service/saving-service/naari-saving'
        },
        {
            id: '6',
            savingName: 'जेष्ठ नागरीक बचत',
            savingImg: JesthaNagarikImg,
            path: '/service/saving-service/jesta-nagarik-saving'
        },
        {
            id: '7',
            savingName: 'स्वास्थ्य बचत',
            savingImg: HealthImg,
            path: '/service/saving-service/health-saving'
        },
        {
            id: '8',
            savingName: 'आवधिक बचत',
            savingImg: AbadhikImg,
            path: '/service/saving-service/aabadhik-saving'
        },
        {
            id: '9',
            savingName: 'अक्षयकोष बचत',
            savingImg: AkshayakoshImg,
            path: '/service/saving-service/akshaya-saving'
        },
        {
            id: '10',
            savingName: 'भविष्य बचत',
            savingImg: FutureImg,
            path: '/service/saving-service/future-saving'
        },
        {
            id: '11',
            savingName: 'चाडपर्व बचत',
            savingImg: FestivalImg,
            path: '/service/saving-service/festival-saving'
        },
        {
            id: '12',
            savingName: 'क्रमिक बचत',
            savingImg: KramikImg,
            path: '/service/saving-service/kramik-saving'
        },
        {
            id: '13',
            savingName: 'ऋण भुक्तानी बचत',
            savingImg: LOanPaymentImg,
            path: '/service/saving-service/loanpayment-saving'
        },
        {
            id: '14',
            savingName: 'प्रतिफल बचत',
            savingImg: PratifalImg,
            path: '/service/saving-service/pratifal-saving'
        },
    ]

    return (
        <>
            <div className='branches-div'>
                <div className='branches-body'>
                    <div className='card-container'>
                        {savingList.map((item, id) => {
                            return (
                                <a href={item.path}>
                                    <div className='card' key={id} data-aos='fade-right'>
                                        <div className='inner'>
                                            <div className='img-holder'>
                                                <img src={item.savingImg} alt='saving-Image' />
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '10px',
                                                        color: 'white',
                                                        backgroundColor: 'rgb(0,166,80)',
                                                        padding: '5px',
                                                        borderRadius: '5px'
                                                    }}
                                                >
                                                    {item.savingName}
                                                </span>
                                                <img src={Logo} alt='logo'
                                                    style={{
                                                        position: 'absolute',
                                                        width: '30px',
                                                        height: '30px',
                                                        top: '10px',
                                                        right: '20px'
                                                    }} />
                                            </div>
                                            <div className='detail'>
                                                <h3>{item.savingName}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SavingAll